import { render, staticRenderFns } from "./TreatmentStepCombo.vue?vue&type=template&id=2deeef0a&scoped=true"
import script from "./TreatmentStepCombo.vue?vue&type=script&lang=js"
export * from "./TreatmentStepCombo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2deeef0a",
  null
  
)

export default component.exports